import { useAuthStore } from "../stores/authStore";

export function useAuth() {
  const {
    user,
    session,
    isLoading,
    isInitialized,
    login,
    register,
    logout,
    checkSession,
    refreshSession,
  } = useAuthStore();

  return {
    user,
    token: session?.access_token ?? null,
    expiresAt: session?.expires_at ?? null,
    isLoading,
    isInitialized,
    isAuthenticated: !!user && !!session,
    login,
    register,
    logout,
    checkSession,
    refreshSession,
  };
}
